import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import messages from "./langs";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
var index = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages: messages
});
locale.i18n(function (key, value) {
  return index.t(key, value);
});
export default index;